import { useUuid } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatActionNext } from '~/components/ChatStep/ChatActions/ChatActionNext';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { useUser } from '~/hooks/useUser/useUser';

import { IntakeRequestComplexStepForm } from './components/IntakeRequestComplexStepForm';
import { useComplexStep } from './IntakeRequestComplexStep.hooks';

export const IntakeRequestComplexStep = ({ role, createdBy, chatSessionCompleted }: ChatMessageProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestComplexStep' });
  const { profile } = useUser({ userId: createdBy });
  const formId = useUuid();

  const { submit, isSubmitting, data } = useComplexStep();
  const isDisabled = chatSessionCompleted || isSubmitting;
  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message')}
      footer={<ChatActionNext formId={formId} disabled={isDisabled} />}
    >
      {data && profile && (
        <IntakeRequestComplexStepForm
          formId={formId}
          data={data}
          profile={profile}
          onSubmit={submit}
          disabled={isDisabled}
        />
      )}
    </ChatStep>
  );
};
